<div class="dashboard-title" [hidden]="true">
    {{titleMessage}}
</div>

<dw-loading [show]="loading"></dw-loading>
<div class="alert alert-danger" *ngIf="errorMessage">{{errorMessage}}</div>

<div [hidden]="loading">
    <div class="dashboard-container-flex">
        <div class="dashboard-column-full">
            <app-school-pass-rates></app-school-pass-rates>
        </div>
    </div>
    <div class="dashboard-container-flex">
        <div class="dashboard-column-left">
            <div class="verticle-container">
                <div class="verticle-item" *ngIf="metarData?.length>0">
                    <dw-container [options]="metarContainerOptions" >
                        <span header>Your METAR Data</span>
                        <div body>

                            <div *ngFor="let metar of metarData">
                                <b>{{metar.airport?.AirportName}} ({{metar.airport?.AirportCode}})</b><br>
                                {{metar.metar}}
                            </div>
                        </div>
                    </dw-container>
                </div>
                <div class="verticle-item-grow">
                    <dw-task-container [tasks]="tasks"></dw-task-container>
                </div>
            </div>
        </div>

        <div class="dashboard-column-right dashboard-calendar" *ngIf="showCalendar">
            <dw-container [options]="calendarContainerOptions">
                <span header>Checkride Calendar</span>
                <div body>
                    <app-school-calendar [compactView]="true"></app-school-calendar>
                </div>
            </dw-container>
        </div>
    </div>
</div>
